import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugin/element'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/mobile.css'
import './styles/mobile-design.css'
import { installI18n } from './i18n'

Vue.config.productionTip = false
installI18n()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
